(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-grid-filters"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const section = document.querySelector('.collection-section');
  if (!section) return; // Safety check
  
  const filterToggles = section.querySelectorAll('.filter-toggle');
  const filterOptions = section.querySelectorAll('.filter-option input');
  const priceMin = section.querySelector('#price-min');
  const priceMax = section.querySelector('#price-max');
  const applyPriceBtn = section.querySelector('[data-action="apply-price"]');
  const products = section.querySelectorAll('.grid-item');
  
  // Updated pagination variables - must match the Liquid pagination value
  let currentPage = 1;
  const itemsPerPage = 1000; // This should match the value in the {% paginate %} tag
  const paginationContainer = section.querySelector('.pagination');
  const paginationNotificationContainer = section.querySelector('.pagination-notification');
  
  // Debug pagination - log if we found the container
  console.log('Pagination container found:', !!paginationContainer);
  
  // Toggle filter groups
  filterToggles.forEach(toggle => {
    toggle.addEventListener('click', function() {
      const filterOptions = document.getElementById(this.getAttribute('aria-controls'));
      const isExpanded = this.getAttribute('aria-expanded') === 'true';
      
      // Toggle aria-expanded
      this.setAttribute('aria-expanded', !isExpanded);
      
      // Toggle icon
      const toggleIcon = this.querySelector('.toggle-icon');
      if (toggleIcon) {
        toggleIcon.textContent = isExpanded ? '+' : '-';
      }
      
      // Toggle content
      filterOptions.classList.toggle('collapsed');
    });
  });
  
  let activeFilters = {
    'collection': [],
    'product-type': [],
    'vendor': [],
    'price': {
      min: null,
      max: null
    }
  };
  
  function updateFilters() {
    // Count how many active filters we have
    const hasActiveFilters = activeFilters['collection'].length > 0 || 
                            activeFilters['product-type'].length > 0 || 
                            activeFilters['vendor'].length > 0 || 
                            activeFilters.price.min !== null || 
                            activeFilters.price.max !== null;
    
    // If no filters are active, we'll use Shopify's server-side pagination
    if (!hasActiveFilters) {
      // Make all products visible - let Shopify handle the pagination
      products.forEach(product => {
        product.style.display = '';
        product.dataset.filterVisible = 'true';
      });
      
      // Make Shopify pagination visible and hide our custom pagination
      if (paginationContainer) {
        paginationContainer.querySelectorAll('a').forEach(link => {
          // Re-enable Shopify's pagination links
          link.style.pointerEvents = '';
          link.style.opacity = '';
        });
      }
      
      console.log('No filters active - using Shopify pagination');
      return;
    }
    
    // When filters are active, we need client-side pagination
    console.log('Filters active - using client-side pagination');
    
    // If we have Shopify pagination links, disable them when filters are active
    if (paginationContainer) {
      paginationContainer.querySelectorAll('a').forEach(link => {
        // Disable Shopify's pagination links when filtering
        link.style.pointerEvents = 'none';
        link.style.opacity = '0.5';
      });
    }
    
    // Apply the filters to determine which products should be visible
    products.forEach(product => {
      // Start with visible and then check filters
      let visible = true;
      
      // Check collection filter
      if (activeFilters['collection'].length > 0) {
        const productCollections = product.dataset.collections ? product.dataset.collections.split(',') : [];
        visible = visible && activeFilters['collection'].some(collection => 
          productCollections.includes(collection)
        );
      }
      
      // Check product type filter
      if (activeFilters['product-type'].length > 0) {
        visible = visible && activeFilters['product-type'].includes(product.dataset.productType);
      }
      
      // Check vendor filter
      if (activeFilters['vendor'].length > 0) {
        visible = visible && activeFilters['vendor'].includes(product.dataset.vendor);
      }
      
      // Check price filter
      if (activeFilters.price.min !== null || activeFilters.price.max !== null) {
        const price = parseFloat(product.dataset.price) / 100; // Convert cents to dollars
        if (activeFilters.price.min !== null && price < activeFilters.price.min) visible = false;
        if (activeFilters.price.max !== null && price > activeFilters.price.max) visible = false;
      }
      
      // Store visibility state for our client-side pagination
      product.dataset.filterVisible = visible ? 'true' : 'false';
    });
    
    // Reset to first page and update display
    currentPage = 1;
    updatePagination();
  }
  
  function updatePagination() {
    // Get products that should be visible based on filters
    const visibleProducts = Array.from(products).filter(p => p.dataset.filterVisible === 'true');
    const totalProducts = visibleProducts.length;
    const totalPages = Math.max(1, Math.ceil(totalProducts / itemsPerPage));
    
    // If no filters are active, let Shopify handle pagination
    const hasActiveFilters = activeFilters['collection'].length > 0 || 
                            activeFilters['product-type'].length > 0 || 
                            activeFilters['vendor'].length > 0 || 
                            activeFilters.price.min !== null || 
                            activeFilters.price.max !== null;
    
    if (!hasActiveFilters) {
      // Make all products visible - Shopify handles which ones appear
      products.forEach(product => {
        product.style.display = '';
      });
      
      // Don't modify the Shopify pagination
      console.log('Using Shopify pagination - all filters inactive');
      return;
    }
    
    // If we get here, we're using client-side pagination for filtered products
    console.log(`Client-side pagination: ${totalProducts} products, ${totalPages} pages, current page: ${currentPage}`);
    
    // Ensure current page is valid
    if (currentPage > totalPages && totalPages > 0) {
      currentPage = totalPages;
    }
    
    // Apply display logic - first hide all products
    products.forEach(product => {
      product.style.display = 'none';
    });
    
    // Then show only visible products for current page
    visibleProducts.forEach((product, index) => {
      const startIndex = (currentPage - 1) * itemsPerPage;
      const endIndex = startIndex + itemsPerPage - 1;
      
      if (index >= startIndex && index <= endIndex) {
        product.style.display = '';
      }
    });
    
    // Generate our custom pagination for filtered results
    if (visibleProducts.length > 0) {
      updatePaginationControls(totalPages);
    } else {
      // No products match filters
      if (paginationNotificationContainer) {
        paginationNotificationContainer.innerHTML = '<div class="no-results">No products match your selected filters</div>';
      }
    }
  }
  
  function updatePaginationControls(totalPages) {
    if (!paginationContainer) return;
    
    // Check if filters are active
    const hasActiveFilters = activeFilters['collection'].length > 0 || 
                            activeFilters['product-type'].length > 0 || 
                            activeFilters['vendor'].length > 0 || 
                            activeFilters.price.min !== null || 
                            activeFilters.price.max !== null;
    
    // If no filters are active, don't modify the Shopify pagination
    if (!hasActiveFilters) {
      console.log('Using default Shopify pagination');
      return;
    }
    
    // Safety check - only create client-side pagination if we have more than one page
    if (totalPages <= 1) {
      // Single page of filtered results
      paginationNotificationContainer.innerHTML = '<div class="pagination-wrapper pagination-filtered">' + 
                                     '<div class="filtered-results-info">Showing filtered results</div>' +
                                     '</div>';
      return;
    }
    
    console.log(`Generating client-side pagination with ${totalPages} pages`);
    
    let paginationHTML = '<div class="pagination-wrapper pagination-filtered">' +
                         '<div class="filtered-results-info">Showing filtered results</div>';
    
    // Previous button
    if (currentPage > 1) {
      paginationHTML += `<a href="#" class="prev" data-page="${currentPage - 1}">&laquo; Previous</a>`;
    } else {
      paginationHTML += `<span class="prev disabled">&laquo; Previous</span>`;
    }
    
    // Page numbers
    const maxPagesToShow = 5;
    let startPage = Math.max(1, currentPage - Math.floor(maxPagesToShow / 2));
    let endPage = Math.min(totalPages, startPage + maxPagesToShow - 1);
    
    // Adjust start if we're near the end
    if (endPage - startPage + 1 < maxPagesToShow) {
      startPage = Math.max(1, endPage - maxPagesToShow + 1);
    }
    
    // First page if not in range
    if (startPage > 1) {
      paginationHTML += `<a href="#" data-page="1">1</a>`;
      if (startPage > 2) {
        paginationHTML += `<span class="deco">...</span>`;
      }
    }
    
    // Page numbers
    for (let i = startPage; i <= endPage; i++) {
      if (i === currentPage) {
        paginationHTML += `<span class="current">${i}</span>`;
      } else {
        paginationHTML += `<a href="#" data-page="${i}">${i}</a>`;
      }
    }
    
    // Last page if not in range
    if (endPage < totalPages) {
      if (endPage < totalPages - 1) {
        paginationHTML += `<span class="deco">...</span>`;
      }
      paginationHTML += `<a href="#" data-page="${totalPages}">${totalPages}</a>`;
    }
    
    // Next button
    if (currentPage < totalPages) {
      paginationHTML += `<a href="#" class="next" data-page="${currentPage + 1}">Next &raquo;</a>`;
    } else {
      paginationHTML += `<span class="next disabled">Next &raquo;</span>`;
    }
    
    paginationHTML += '</div>';
    paginationContainer.innerHTML = paginationHTML;
    
    // Add event listeners to the new pagination links
    const paginationLinks = paginationContainer.querySelectorAll('a[data-page]');
    paginationLinks.forEach(link => {
      link.addEventListener('click', function(e) {
        e.preventDefault();
        currentPage = parseInt(this.dataset.page);
        updatePagination();
        
        // Scroll to top of collection
        section.scrollIntoView({ behavior: 'smooth' });
      });
    });
  }
  
  // Add clear filters button
  function addClearFiltersButton() {
    // Create a clear filters button
    const clearButton = document.createElement('button');
    clearButton.className = 'clear-filters';
    clearButton.textContent = 'Clear All Filters';
    
    // Add it after the last filter group
    const lastFilterGroup = section.querySelector('.filter-group:last-child');
    if (lastFilterGroup) {
      lastFilterGroup.after(clearButton);
      
      // Add event listener to clear all filters
      clearButton.addEventListener('click', function() {
        // Uncheck all filter checkboxes
        filterOptions.forEach(option => {
          option.checked = false;
        });
        
        // Clear price inputs
        if (priceMin) priceMin.value = '';
        if (priceMax) priceMax.value = '';
        
        // Reset active filters
        activeFilters = {
          'collection': [],
          'product-type': [],
          'vendor': [],
          'price': {
            min: null,
            max: null
          }
        };
        
        // Update display
        updateFilters();
        
        // Hide the clear button
        clearButton.style.display = 'none';
      });
    }
    
    return clearButton;
  }
  
  // Create the clear filters button
  const clearFiltersButton = addClearFiltersButton();
  clearFiltersButton.style.display = 'none'; // Hide initially
  
  // Update the filter option change handler to show/hide clear button
  filterOptions.forEach(option => {
    option.addEventListener('change', function() {
      const filterType = this.closest('.filter-options').dataset.filter;
      const value = this.value;
      
      if (this.checked) {
        // Add the value to the active filters
        activeFilters[filterType].push(value);
        clearFiltersButton.style.display = 'block';
      } else {
        // Remove the value from the active filters
        const index = activeFilters[filterType].indexOf(value);
        if (index > -1) activeFilters[filterType].splice(index, 1);
        
        // Check if we should hide the clear button
        const hasActiveFilters = activeFilters['collection'].length > 0 || 
                                activeFilters['product-type'].length > 0 || 
                                activeFilters['vendor'].length > 0 || 
                                activeFilters.price.min !== null || 
                                activeFilters.price.max !== null;
        if (!hasActiveFilters) {
          clearFiltersButton.style.display = 'none';
        }
      }
      
      updateFilters();
    });
  });
  
  // Apply price filter
  if (applyPriceBtn) {
    applyPriceBtn.addEventListener('click', function() {
      activeFilters.price.min = priceMin.value ? parseFloat(priceMin.value) : null;
      activeFilters.price.max = priceMax.value ? parseFloat(priceMax.value) : null;
      
      // Show clear button if price filter applied
      if (activeFilters.price.min !== null || activeFilters.price.max !== null) {
        clearFiltersButton.style.display = 'block';
      }
      
      updateFilters();
    });
  }
  
  // Initialize on page load
  updateFilters();
});

  } catch(e) { console.error(e); }
})();
})();
